export default function convertToSlug(inputString: string) {
  return (
    inputString &&
    inputString
      .toLowerCase() // Convert to lowercase
      .replace(/\s+/g, '-')
      .replace('/', '@')
      // .replace(/[^\w-]+/g, '') // Remove non-word characters (excluding hyphens)
      .replace(/--+/g, '-')
  ); // Replace multiple hyphens with a single hyphen
}

export function slugToTitle(slug: string) {
  return (
    slug &&
    slug
      .replace('@', '/')
      .split('-') // Split the slug into an array of words
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize the first letter of each word
      .join(' ')
  ); // Join the words with a space
}

export function replaceSlash(inputSting: string) {
  return inputSting && inputSting?.replace(/\//g, '@');
}

export function checkForSlash(inputString: string) {
  return inputString && inputString?.replace('@', '/');
}
